import React from "react";
import { TopBarButton } from "components/PageTopNav/styled";
import { Navigation } from "interfaces/navigation";
import { useLocation, useNavigate } from "react-router-dom";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import {
	ClubShopIcon,
	CrownIcon,
	NewsIcon,
	ShopIcon,
	DailyGiftIcon,
	ClubGiftIcon,
	PoisBountyIcon,
	DripOfferIcon,
	FriendCenterIcon,
	EliteDealsIcon
} from "utils/svgIcons";
import { isPageActive } from "helpers/isPageActive";

interface Props {
	page: Navigation;
}

export const MenuOption: React.FC<Props> = ({ page }) => {
	const location = useLocation();
	const { reportEvent } = useGoogleAnalyticsContext();
	const navigate = useNavigate();
	const isActive = isPageActive(location.pathname, page);

	const onClick = (page: Navigation) => {
		reportEvent(page.analytics_key, { source: "navbar" });
		navigate(page.path);
	};

	return (
		<TopBarButton
			color={isActive ? "#113b62" : "#fff"}
			background={isActive ? "#FFF" : "rgba(17, 59, 98, 0.75)"}
			onClick={() => onClick(page)}
		>
			{page.icon === "store" && <ShopIcon />}
			{page.icon === "club" && <ClubShopIcon />}
			{page.icon === "crown" && <CrownIcon />}
			{page.icon === "news" && <NewsIcon />}
			{page.icon === "daily-gift" && <DailyGiftIcon />}
			{page.icon === "club-gift" && <ClubGiftIcon />}
			{page.icon === "pois-bounty" && <PoisBountyIcon />}
			{page.icon === "drip-offer" && <DripOfferIcon />}
			{page.icon === "friend-center" && <FriendCenterIcon />}
			{page.icon === "elite-deals" && <EliteDealsIcon />}
			<span>{page.title}</span>
		</TopBarButton>
	);
};
